import { Loader, Text, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, Fragment, PropsWithChildren, useEffect } from "react";
import {
  LocalControlCenterActions,
  useControlCenterContext,
} from "../../../stores/ControlCenterContext";

interface IMaybeJoyrideLoadingAnimationWrapperProps {
  animationTimeoutInMs?: number;
}

const MaybeJoyrideLoadingAnimationWrapper: FC<
  PropsWithChildren<IMaybeJoyrideLoadingAnimationWrapperProps>
> = ({ animationTimeoutInMs = 1200, children }) => {
  const {
    dispatchers: { localDispatch },
    state: {
      localState: {
        guides: { activeChapter, activeGuideId, showLoadingAnimation },
      },
    },
  } = useControlCenterContext();
  const currentGuide = activeChapter?.guides.find((guide) => guide.joyride.id === activeGuideId);

  useEffect(() => {
    if (activeGuideId) {
      setTimeout(() => {
        LocalControlCenterActions.guides.showGuidesLoadingAnimation(false, localDispatch);
        LocalControlCenterActions.guides.setActiveGuideId(undefined, localDispatch);
        LocalControlCenterActions.guides.runGuide(true, localDispatch);
      }, animationTimeoutInMs);
    }
  }, [activeGuideId, animationTimeoutInMs, localDispatch]);

  return (
    <Fragment key="MaybeJoyrideAnimationWrapper">
      {children}

      {activeGuideId && showLoadingAnimation && (
        <div
          className={cx(
            "fixed z-50 flex w-96 items-center justify-center rounded-lg motion-safe:animate-pulse",
            toolkitCx.layout.background.default,
            toolkitCx.layout.spacing.both.lg,
            toolkitCx.layout.border.default,
            toolkitCx.layout.border.weight.default,
            toolkitCx.recipes.center.both()
          )}
        >
          <div className="relative z-10 grid w-full gap-4">
            <div className="grid place-items-center gap-1 text-center">
              <Text tag="span" size="xs" variant="silent">
                Loading Guide
              </Text>
              <Text className="mx-auto w-4/5" tag="span" gradient size="lg" weight="semibold">
                {currentGuide?.title}
              </Text>
            </div>
            <Loader className="mx-auto" size="small" />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default MaybeJoyrideLoadingAnimationWrapper;
